<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="gestraald-glas-section">
      <h1 class="gestraald-glas-title">Gestraald glas</h1>
      <span class="gestraald-glas-text11">
        Bij Theo brandt kunt uw ook terecht voor gestraald glas. Gestraald glas
        is een vorm van decoreren die in de glaskunst wordt gebruikt waarbij je
        het glas decoreerd met zandstralen.
      </span>

      <br />

      <div class="gestraald-glas-container19">
        <div class="gallery">
          <h1 class="gestraald-glas-text15">Galerij van werk</h1>
          <span class="gestraald-glas-text16">
            <span>
              <span>
                In deze galerij kunt u de gestraald glas projecten van Theo
                Brandt zien.
                <span v-html="rawn714"></span>
              </span>
              <span><span v-html="rawmtty"></span></span>
            </span>
          </span>

          <div class="gestraald-glas-container20">
            <gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.24 (1).jpeg"
              title="Gestraald glas 1"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.24 (2).jpeg"
              title="Gestraald glas 2"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.24 (3).jpeg"
              title="Gestraald glas 3"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.24 (4).jpeg"
              title="Gestraald glas hoeken afbeelding 2"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.24.jpeg"
              title="Gestraald glas 4"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.50 (1).jpeg"
              title="Gestraald glas 5"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.50 (2).jpeg"
              title="Gestraald glas 6"
              rootClassName="rootClassName"
            ></gallery-card32
            ><gallery-card32
              imageSrc="/gestraald/WhatsApp Image 2024-12-08 at 09.10.50.jpeg"
              title="Gestraald glas 7"
              rootClassName="rootClassName"
            ></gallery-card32>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import GalleryCard32 from "../components/gallery-card32.vue";

export default {
  name: "GestraaldGlas",
  components: {
    Navbar,
    Footer,
    GalleryCard32,
  },
  metaInfo: {
    title: "Gestraald glas - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Gestraald glas - Langglas",
      },
    ],
  },
};
</script>

<style scoped>
.gestraald-glas-container19 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}

.gallery {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}

.footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}

.gestraald-glas-container20 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center; /* Centers items horizontally */
  align-items: center; /* Centers items vertically */
}

.gestraald-glas-text15 {
  font-size: 3rem;
  text-align: center;
  padding-bottom: 20px;
}

.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.gestraald-glas-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
}

.gestraald-glas-text11 {
  max-width: 50%;
  margin-top: 32px;
  text-align: center;
  margin-bottom: 32px;
  max-width: 600px;
}

.gestraald-glas-text16 {
  color: var(--dl-color-gray-700);
  margin-top: 32px;
  text-align: center;
  padding-left: 48px;
  margin-bottom: 32px;
  padding-right: 48px;
}

.gestraald-glas-section {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
  padding: 48px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.gestraald-glas-title {
  font-size: 3rem;
  align-self: center;
  text-align: center;
  padding-top: 100px;
}

@media (max-width: 1600px) {
  .gestraald-glas-container20 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .gallery {
    padding-left: 32px;
    padding-right: 32px;
  }

  .gestraald-glas-text16 {
    padding-left: 32px;
    padding-right: 32px;
  }

  .gestraald-glas-text15 {
    font-size: 2.5rem;
  }

  .gestraald-glas-title {
    font-size: 2.5rem;
  }

  .gestraald-glas-text11 {
    max-width: 70%;
  }

  .gestraald-glas-title {
    font-size: 2.5rem;
  }
}

@media (max-width: 1200px) {
  .gestraald-glas-container20 {
    grid-template-columns: 1fr 1fr;
  }

  .gallery {
    padding-left: 16px;
    padding-right: 16px;
  }

  .gestraald-glas-text16 {
    padding-left: 16px;
    padding-right: 16px;
  }

  .gestraald-glas-text15 {
    font-size: 2rem;
  }

  .gestraald-glas-title {
    font-size: 2rem;
  }

  .gestraald-glas-text11 {
    max-width: 80%;
  }

  .gestraald-glas-title {
    font-size: 2rem;
  }
}

@media (max-width: 991px) {
  .gestraald-glas-container20 {
    grid-template-columns: 1fr 1fr;
  }

  .gestraald-glas-title {
    padding-top: 80px;
  }

  .gestraald-glas-text11 {
    max-width: 90%;
  }

  .gestraald-glas-text16 {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gallery {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gestraald-glas-text15 {
    font-size: 1.5rem;
  }
}

@media (max-width: 840px) {
  .gestraald-glas-container20 {
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
    margin-right: 70px;
  }

  .gestraald-glas-title {
    margin-top: 50px;
  }

  .gestraald-glas-text11 {
    max-width: 100%;
  }

  .gestraald-glas-text16 {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gallery {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gestraald-glas-text15 {
    font-size: 1.5rem;
  }
}

@media (max-width: 479px) {
  .gestraald-glas-container20 {
    grid-template-columns: 1fr;
  }

  .gestraald-glas-title {
    padding-top: 40px;
  }

  .gestraald-glas-text11 {
    max-width: 100%;
  }

  .gestraald-glas-text16 {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gallery {
    padding-left: 8px;
    padding-right: 8px;
  }

  .gestraald-glas-text15 {
    font-size: 1.5rem;
  }
}
</style>
